import { gamesImagesData } from "../../utils/data/homePage.data";
import {
  CasinoTagsEnum,
  EXCHANGE_EVENT_TYPES,
  fetchCasinoGamesBySections,
  fetchInplayEvent,
  fetchNotifications,
  getInplayEvents,
  ICasinoGame,
  LOGIN_ROUTE,
  RootState,
  RULES_ROUTE,
  setCompetition,
  setEventType,
  setIsLoginModalOpen,
  useAppDispatch,
  useAppSelector,
} from "@hypexone/uicore";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LICImage from "../../assets/images/Casino_svg_img/LIC.svg";
import { commonPaddingBottomForMobile } from "../../utils/constants/common.constants";
import Popup from "../components/home/Popup";
import HomeBannerCarousel from "../components/home/HomeBannerCarousel";
import MobileFooter from "../components/mobile-footer/MobileFooter";
import NewsAndPromotions from "../components/shared/NewsAndPromotions";
import Header from "../components/header/Header";
import LiveGif from "../../assets/images/Casino_svg_img/Live.svg";
import ProvidersSection from "./ProvidersSection";
import { isDesktop, isIOS, isMobile } from "react-device-detect";
import { appNavigationConstants } from "../../utils/constants/header.constants";
import { connect } from "react-redux";
import {
  BannerObjData,
} from "@hypexone/uicore/lib/cjs/src/models/Banners";
import HomeGames from "./WithdrawAmount/HomeGames";
import { accountClient } from "../../App.utils";
import { BRAND_DOMAIN, domain } from "../../constants/Branding";
import ClientSecurityMessageModal from "../components/header/ClientSecurityMessageModal";
import SkinsRail from "../components/header/SkinsRail";
import YuviGames from "../components/YuviGames/YuviGames";
import FantasySportsSection from "../components/home/FantasySportsSection";
import whatsappIconGreen from "../../assets/icons/user-menu-icons/whatsapp-icon-green.svg";
import { IconType } from "react-icons";
import { FaInstagram, FaPaperPlane } from "react-icons/fa6";
import { IoLogoWhatsapp } from "react-icons/io5";
import { RiCustomerService2Fill } from "react-icons/ri";
// Local banner assets (set USE_LOCAL_BANNERS to false to restore API banners)
import colorPredictionBanner from "../../assets/images/home-images/color_prediction.gif";
import aviatorBanner from "../../assets/images/home-images/aviator.gif";
import marbleRunBanner from "../../assets/images/home-images/marble-run.gif";
import minesBanner from "../../assets/images/home-images/mines.gif";

// Footer policy links. Only Rules has a page in this app today; the rest need a
// destination before they navigate — set `href` here once those exist.
const FOOTER_POLICY_LINKS: { label: string; href?: string }[] = [
  { label: "Privacy Policy" },
  { label: "Terms and Conditions" },
  { label: "Rules and Regulations", href: RULES_ROUTE },
  { label: "KYC" },
  { label: "Responsible Gaming" },
  { label: "About Us" },
  { label: "Self-Exclusion Policy" },
  { label: "Underage Policy" },
];

const APK_VERSION_INFO = "v1.15 - 2025/09/17 - 3.1MB";

const USE_LOCAL_BANNERS = true;
const CHICKEN_GAMES_URL = "/casino?subProvider=CHICKEN+GAMES&category=ALL";
const COLOR_GAMES_URL = "/casino?subProvider=Color+Games&category=ALL";

type LocalBannerData = BannerObjData & {
  splitRedirectionUrls?: {
    leftUrl: string;
    rightUrl: string;
  };
};

const localBanner = (
  id: number,
  title: string,
  publicUrl: string,
  deviceType: string,
  redirectionUrl: string,
  splitRedirectionUrls?: LocalBannerData["splitRedirectionUrls"],
): LocalBannerData => ({
  id,
  houseId: 0,
  bannerId: "",
  sportsBookUrl: "",
  title,
  category: "",
  deviceType,
  level: 0,
  publicUrl,
  redirectionUrl,
  imageContent: "",
  displayContent: "",
  active: true,
  splitRedirectionUrls,
});
const LOCAL_BANNERS: LocalBannerData[] = [
  localBanner(
    1,
    "Aviator Game",
    aviatorBanner,
    "desktop",
    "/casino?category=aviator",
  ),
  localBanner(
    2,
    "Mines Game",
    minesBanner,
    "desktop",
    "/casino?category=mines",
  ),
  localBanner(
    3,
    "Marble Run",
    marbleRunBanner,
    "desktop",
    "/dc/gamev1.1/marble-run-MTUxMTg3-TUFDODgtQ01SMTAx-TUFDODg=-TWFjODggR2FtaW5nIFZpcnR1YWw=-TUFDSFVC",
  ),
  localBanner(
    4,
    "Chicken Games",
    colorPredictionBanner,
    "desktop",
    "/casino?subProvider=COLOR+AND+CHICKEN+GAMES&category=ALL",
    {
      leftUrl: CHICKEN_GAMES_URL,
      rightUrl: COLOR_GAMES_URL,
    },
  ),
  localBanner(
    5,
    "Aviator Game",
    aviatorBanner,
    "mobile",
    "/casino?category=aviator",
  ),
  localBanner(6, "Mines Game", minesBanner, "mobile", "/casino?category=mines"),
  localBanner(
    7,
    "Marble Run",
    marbleRunBanner,
    "mobile",
    "/dc/gamev1.1/marble-run-MTUxMTg3-TUFDODgtQ01SMTAx-TUFDODg=-TWFjODggR2FtaW5nIFZpcnR1YWw=-TUFDSFVC",
  ),
  localBanner(
    8,
    "Chicken Games",
    colorPredictionBanner,
    "mobile",
    "/casino?subProvider=COLOR+AND+CHICKEN+GAMES&category=ALL",
    {
      leftUrl: CHICKEN_GAMES_URL,
      rightUrl: COLOR_GAMES_URL,
    },
  ),
];
import { MdOutlineCancel } from "react-icons/md";
import downloadAndroidApp from "../../assets/images/download-android-app.png";
import downloadAndroidAppQr from "../../assets/images/download-android-app-qr.png";
import QRCode from "react-qr-code";
import {
  getEnvVariable,
} from "../../constants/brandConfig";
import Modal from "../components/shared/ModalComponent";
import Button from "../components/shared/Button/Button";

const HomePage = ({ loggedIn, balance, exposure }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { langData } = useAppSelector((state) => state.cms);
  const { domainConfig, whatsappDetails } = useAppSelector(
    (state) => state.common,
  );
  const whatsappLink = loggedIn
    ? whatsappDetails
    : domainConfig?.suppportContacts?.find(
        (ct: { contactType?: string }) =>
          ct.contactType === "REGISTRATION_WHATSAPP_LINK",
      )?.details;
  // Footer contact cards. contactType strings are set per house by the backend,
  // so groups match on a substring rather than an exact key.
  const contactsMatching = (match: string): string[] =>
    (domainConfig?.suppportContacts ?? [])
      .filter((ct: { contactType?: string; details?: string }) =>
        ct?.contactType?.toUpperCase().includes(match),
      )
      .map((ct: { details?: string }) => ct?.details)
      .filter(Boolean);

  const FOOTER_CONTACT_GROUPS: {
    match: string;
    label: string;
    Icon: IconType;
    fullWidth?: boolean;
    // Placeholder rows shown until support_contacts is configured — remove once it is
    dummy: { label: string; href: string }[];
  }[] = [
    {
      match: "WHATSAPP",
      label: "WhatsApp",
      Icon: IoLogoWhatsapp,
      fullWidth: true,
      dummy: [
        { label: "WhatsApp 3", href: "#" },
        { label: "WhatsApp 4", href: "#" },
      ],
    },
    {
      match: "SUPPORT",
      label: "Customer support",
      Icon: RiCustomerService2Fill,
      fullWidth: true,
      dummy: [
        { label: "Customer support1", href: "#" },
        { label: "support2", href: "#" },
      ],
    },
    {
      match: "EMAIL",
      label: "Email",
      Icon: FaPaperPlane,
      dummy: [{ label: "Email", href: "#" }],
    },
    {
      match: "INSTAGRAM",
      label: "Instagram",
      Icon: FaInstagram,
      dummy: [{ label: "skyexchindia", href: "#" }],
    },
  ];

  const contactHref = (group: string, value: string) =>
    group === "EMAIL" && !value.startsWith("mailto:") && value.includes("@")
      ? `mailto:${value}`
      : value;

  const allowedTrendingNames = [
    "coin flip",
    "fortune wheel",
    "twistx",
    "lucky 5",
    "rock paper scissors",
    "valentine",
    "bolly kiss",
    "limbo",
    "plinko",
    "crash x",
    "diamonds",
    "pushpa rani",
    "dice",
  ];
  // const { loggedIn } = useAppSelector((state) => state.auth);
  //const CRICKET_BATTLE_ROUTE ="/dc/gamev1.1/cricket-battle-MTUxMTg1-TUFDODgtWENSQjEwMQ==-TUFDODg=-TWFjODggR2FtaW5nIFZpcnR1YWw=-TUFDSFVC";
  const [bannersData, setBannersData] = useState<BannerObjData[]>([]);
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  // Before and After Login Banners
  const [popupBanner, setPopupBanner] = useState<BannerObjData>();
  const [downloadApkBanner, setDownloadApkBanner] = useState<BannerObjData>();
  const [popupMobileBanner, setPopupMobileBanner] = useState<BannerObjData>();
  const [downloadApkMobileBanner, setDownloadApkMobileBanner] =
    useState<BannerObjData>();
  const [showApkPopup, setShowApkPopup] = useState(false);
  const [showApkQrModal, setShowApkQrModal] = useState(false);
  const [isApkAvailable, setIsApkAvailable] = useState<boolean>(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showWhatsapp, setShowWhatsapp] = useState<boolean>(true);
  const [casinoGames, setCasinoGames] = useState<ICasinoGame[]>([]);
  const [fantasyGames, setFantasyGames] = useState<ICasinoGame[]>([]);
  const [casinoLobby, setCasinoLobby] = useState<ICasinoGame[]>([]);

  const apkUrl = getEnvVariable(domain, "apk_url") || domainConfig?.apkUrl;
  // Falls back to APK_VERSION_INFO until a house sets apk_meta in its env config
  const apkMeta = getEnvVariable(domain, "apk_meta") || APK_VERSION_INFO;

  const fetchBanners = async () => {
    const response = await accountClient.getBannersByCategory(
      BRAND_DOMAIN,
      "diamondgifs",
    );
    setBannersData(response?.banners);
  };
  useEffect(() => {
    fetchBanners();
  }, []);

  useEffect(() => {
    if (loggedIn) {
      dispatch(fetchNotifications());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedIn]);

  // The Blogs tile links to the domain's WhatsApp contact, which is external
  const openWhatsapp = () => {
    if (!whatsappLink) return;
    const target = whatsappLink.startsWith("http")
      ? whatsappLink
      : `https://${whatsappLink}`;
    window.open(target, "_blank", "noreferrer");
  };

  function handleNavigation(url: string) {
    // Check if the user is trying to navigate to /sportsbook and if they are logged in
    if (url === "/sportsbook" && !loggedIn) {
      setShowLoginPopup(true); // Show the popup if not logged in
      return; // Stop the navigation
    }
    //if (url === CRICKET_BATTLE_ROUTE && !loggedIn) {
    //  setShowLoginPopup(true); // Show the popup if not logged in
    //  return; // Stop the navigation
    //}
    navigate(url); // Navigate if allowed
  }

  const { events: catalogEvents, selectedEventType } = useAppSelector(
    (state) => state.catalog,
  );
  const { allowedConfig } = useAppSelector((state) => state.common);

  const inplayEvents = getInplayEvents(catalogEvents, allowedConfig);

  // Create a combined array of all sports with their event counts
  const allSportsWithCounts = EXCHANGE_EVENT_TYPES.map((sport) => {
    const inplayEvent = inplayEvents.find(
      (event) => event?.sportName?.toLowerCase() === sport?.name?.toLowerCase(),
    );
    return {
      ...sport,
      eventCount: inplayEvent ? inplayEvent.events.length : 0,
      sportName: sport.name,
    };
  });

  useEffect(() => {
    dispatch(fetchInplayEvent());
  }, []);

  const getApkPopupBanners = async () => {
    try {
      const data = await accountClient.getBannersByCategory(
        BRAND_DOMAIN,
        "apkpopupbanner",
      );
      if (data?.banners && data.banners.length >= 2) {
        const desktop = data.banners.filter((b) => b.deviceType === "desktop")[0];
        const mobile = data.banners.filter((b) => b.deviceType === "mobile")[0];
        if (desktop && mobile) {
          setDownloadApkBanner(desktop);
          setDownloadApkMobileBanner(mobile);
          setShowApkPopup(true);
        }
      }
    } catch {
      // ignore banner fetch errors so app does not crash
    }
  };

  const getPopupBanners = async () => {
    try {
      const data = await accountClient.getBannersByCategory(
        BRAND_DOMAIN,
        "popupbanner",
      );
      if (data?.banners && data.banners.length >= 2) {
        const desktop = data.banners.filter((b) => b.deviceType === "desktop")[0];
        const mobile = data.banners.filter((b) => b.deviceType === "mobile")[0];
        if (desktop && mobile) {
          setPopupBanner(desktop);
          setPopupMobileBanner(mobile);
        }
      }
    } catch {
      // ignore banner fetch errors so app does not crash
    }
  };

  useEffect(() => {
    if (!sessionStorage.getItem("popup_shown")) {
      getPopupBanners();
    }
  }, []);

  const closePopup = () => {
    sessionStorage.setItem("popup_shown", "true");
    setShowPopup(false);
  };

  const handlePopupBannerClick = () => {
    const banner = isMobile ? popupMobileBanner : popupBanner;
    const redirectionUrl = banner?.redirectionUrl?.trim();
    if (!redirectionUrl) return;

    closePopup();
    if (redirectionUrl.startsWith("/")) {
      navigate(redirectionUrl);
    }
  };

  useEffect(() => {
    if (loggedIn && !sessionStorage.getItem("popup_shown")) {
      setShowPopup(true);
    }
  }, [loggedIn]);

  useEffect(() => {
    if (!sessionStorage.getItem("apk_popup_shown") && isApkAvailable) {
      getApkPopupBanners();
    }
  }, [isApkAvailable]);

  const closeApkPopup = () => {
    sessionStorage.setItem("apk_popup_shown", "true");
    setShowApkPopup(false);
  };

  useEffect(() => {
    setIsApkAvailable(!!apkUrl);
  }, [apkUrl]);

  const apkDownloadUrl = apkUrl
    ? apkUrl.startsWith("http")
      ? apkUrl
      : `https://${apkUrl}`
    : "";

  const downloadApp = () => {
    if (!apkDownloadUrl) return;
    const link = document.createElement("a");
    link.href = apkDownloadUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    const fetchGames = async () => {
      try {
        const result = await dispatch(
          fetchCasinoGamesBySections({
            tag: `sky_casino`,
          })
        );

        const games = (result?.payload as ICasinoGame[]) || [];
        setCasinoGames(games);
        setFantasyGames(games.filter(game => game.sectionCode == 'fantasy_sports'));
        // Top Providers banners come back under the sky_casino section
        setCasinoLobby(games.filter(game => game.sectionCode == 'sky_casino'));
      } catch (error) {
        console.error("Error fetching casino games:", error);
        setCasinoGames([]);
      }
    };

    fetchGames();
  }, []);

  return (
    <div className="flex h-full w-full flex-col overflow-auto bg-[#eee] mb-64 router-ctn">
      <Header balance={balance} exposure={exposure} loggedIn={loggedIn} />
      <div
        className={`m-auto flex w-full flex-1 flex-col overflow-auto bg-gray11 hide-scrollbar pb-32 md:max-w-[85%] ${commonPaddingBottomForMobile}`}
      >
        <div className="flex flex-col">
          <div className="hidden md:block">
            <NewsAndPromotions />
          </div>
          <div className="w-full">
            <HomeBannerCarousel />
            {/* {fantasyGames.length > 0 && <FantasySportsSection fantasyGames={fantasyGames} />} */}
          </div>
          <div className="relative flex flex-col space-y-0.5 mt-0">
            <div className="grid grid-cols-4 md:grid-cols-12 gap-y-0.5 gap-x-0 md:gap-[8px] w-full md:py-3 pt-2">
              {gamesImagesData.map(
                (
                  { imageSrc, url, alt, customClassName, title, isWhatsapp },
                  index,
                ) => {
                  // Grid is 4 cols on mobile, 12 on desktop — shared with the
                  // provider cards, so they flow in beside a half-width tile.
                  const computedClass = "col-span-4 md:col-span-6";

                  return (
                    <div
                      key={index}
                      className={`w-full cursor-pointer relative md:aspect-[32/10] md:overflow-hidden ${computedClass}`}
                    >
                      <img
                        onClick={() =>
                          isWhatsapp
                            ? openWhatsapp()
                            : url && handleNavigation(url)
                        }
                        src={imageSrc}
                        alt={alt}
                        className="w-full h-auto object-cover md:absolute md:inset-0 md:h-full md:w-full"
                      />

                      {index === 0 && (
                        <div className="absolute right-0 top-0 z-0 h-[calc(100%-32px)] bg-gradient-to-b from-black/95 to-black/30 w-[120px] md:w-[160px] text-white overflow-auto p-2">
                          <div className="w-16 h-5 overflow-hidden">
                            <img
                              className="object-cover h-4"
                              src={LiveGif}
                              alt="LiveGif"
                            />
                          </div>
                          <div className="flex flex-col gap-1">
                            {allSportsWithCounts.map(
                              (sport) =>
                                sport?.eventCount > 0 && (
                                  <div
                                    key={sport.id}
                                    className="text-[11px] leading-[10px] md:text-xs flex justify-between md:font-bold capitalize"
                                    onClick={() => {
                                      dispatch(
                                        setCompetition({
                                          id: "",
                                          name: "",
                                          slug: "",
                                        }),
                                      );
                                      dispatch(
                                        setEventType({
                                          id: sport.id,
                                          name: sport.name,
                                          slug: sport.slug,
                                        }),
                                      );
                                      navigate(
                                        `/exchange_sports/${sport.slug}`,
                                      );
                                    }}
                                  >
                                    <div>{sport.sportName}</div>
                                    <div className="bg-white text-black rounded-sm py-[2px] px-1 font-normal">
                                      {sport.eventCount}
                                    </div>
                                  </div>
                                ),
                            )}
                          </div>
                        </div>
                      )}

                      {title && (
                        // <div className="w-full bg-black text-center uppercase font-bold text-white p-1 px-2 text-xs md:text-sm">
                        //   {title}
                        // </div>
                        <div
                          className="flex w-full h-[32px] sm:h-[24px] flex-shrink-0 absolute bottom-0 left-0 right-0 border-b-4 border-goldenYellow"
                          onClick={() =>
                            isWhatsapp
                              ? openWhatsapp()
                              : url && handleNavigation(url)
                          }
                        >
                          <div className="flex flex-1 items-center bg-gradient-to-r from-black to-transparent text-white pl-2 pr-1 py-1 text-[11px] font-bold cursor-pointer min-w-0">
                            <span className="truncate">{title}</span>
                          </div>
                          <button
                            type="button"
                            className="flex items-center justify-center flex-shrink-0 bg-goldenYellow bg-[linear-gradient(110deg,#FFB600_0%,#FFB600_38%,#FFF1B8_50%,#FFB600_62%,#FFB600_100%)] bg-[length:250%_100%] animate-playNow text-[#1A1A1A] px-2 pl-4 py-1 text-[12px] font-extrabold leading-[120%] tracking-[0.02em] [text-shadow:0_1px_0_rgba(255,255,255,0.6)] cursor-pointer min-w-[70px] [clip-path:polygon(15%_0,100%_0,100%_100%,0_100%)] hover:brightness-110"
                          >
                            Play Now
                          </button>
                        </div>
                      )}
                    </div>
                  );
                },
              )}

              {/* Desktop only: `contents` lets the cards flow into this grid,
                  filling the space beside the half-width Sports Book tile */}
              {casinoLobby.length > 0 && (
                <div className="hidden md:contents">
                  <ProvidersSection
                    casinoLobby={casinoLobby}
                    isLoggedIn={loggedIn}
                    showPopUp={() => setShowLoginPopup(true)}
                  />
                </div>
              )}

              {showLoginPopup && (
                <Modal
                  isOpen={showLoginPopup}
                  onClose={() => setShowLoginPopup(false)}
                  title={langData?.["notice"]}
                >
                  <p className="mb-4">
                    Access required for gameplay. Please log in to proceed.
                  </p>
                  <Button
                    className="rounded py-2 px-6 text-white bg-slate-800"
                    onClick={() => setShowLoginPopup(false)}
                  >
                    OK
                  </Button>
                </Modal>
              )}
            </div>

            {/* Mobile keeps providers in their own grid, as before */}
            {casinoLobby.length > 0 && (
              <div className="md:hidden grid grid-cols-4 gap-[6px] w-full py-1 pb-2">
                <ProvidersSection
                    casinoLobby={casinoLobby}
                    isLoggedIn={loggedIn}
                    showPopUp={() => setShowLoginPopup(true)}
                  />
              </div>
            )}
            {/* <div className="grid  grid-cols-2 sm:grid-cols-2 gap-0.5">
              {(USE_LOCAL_BANNERS ? LOCAL_BANNERS : bannersData)?.map(
                (banner, index) => {
                  const splitUrls = (banner as LocalBannerData).splitRedirectionUrls;
                  const bannerNavigate =
                    banner.redirectionUrl !== "nourl"
                      ? () => navigate(banner.redirectionUrl)
                      : undefined;
                  const chickenNavigate = splitUrls
                    ? () => navigate(splitUrls.leftUrl)
                    : bannerNavigate;

                  return banner.deviceType === "desktop" ? (
                    <div
                      className="hidden md:block relative"
                      key={banner.id + index + "desktop"}
                    >
                      <div className="relative">
                        {splitUrls ? (
                          <div className="absolute inset-0 bottom-[33px] z-10 flex">
                            <button
                              type="button"
                              className="w-1/2 h-full cursor-pointer bg-transparent border-0 p-0"
                              onClick={() => navigate(splitUrls.leftUrl)}
                              aria-label="Chicken Games"
                            />
                            <button
                              type="button"
                              className="w-1/2 h-full cursor-pointer bg-transparent border-0 p-0"
                              onClick={() => navigate(splitUrls.rightUrl)}
                              aria-label="Color Games"
                            />
                          </div>
                        ) : null}
                        <img
                          key={banner.id + index + "desktop"}
                          src={banner.publicUrl}
                          alt={banner.title}
                          className="w-[100%] cursor-pointer"
                          onClick={splitUrls ? undefined : bannerNavigate}
                        />
                      </div>
                      <div className="flex w-full h-[33px] flex-shrink-0 absolute bottom-0 left-0 right-0 border-b-4 border-goldenYellow z-[1]">
                        <div
                          className="flex flex-1 items-center bg-gradient-to-r from-black to-transparent text-white pl-2 pr-1 py-1 text-xs md:text-sm font-bold cursor-pointer min-w-0 uppercase break-words"
                          onClick={chickenNavigate}
                        >
                          {banner.title}
                        </div>
                        <button
                          type="button"
                          className="flex items-center justify-center flex-shrink-0 bg-goldenYellow bg-[linear-gradient(110deg,#FFB600_0%,#FFB600_38%,#FFF1B8_50%,#FFB600_62%,#FFB600_100%)] bg-[length:250%_100%] animate-playNow text-[#1A1A1A] px-2 pl-4 py-1 text-[12px] font-extrabold leading-[120%] tracking-[0.02em] [text-shadow:0_1px_0_rgba(255,255,255,0.6)] cursor-pointer min-w-[70px] [clip-path:polygon(15%_0,100%_0,100%_100%,0_100%)] hover:brightness-110"
                          onClick={(e) => {
                            e.stopPropagation();
                            chickenNavigate?.();
                          }}
                        >
                          Play Now
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="md:hidden relative"
                      key={banner.id + index + "mobile"}
                    >
                      <div className="relative">
                        {splitUrls ? (
                          <div className="absolute inset-0 z-10 flex pb-8">
                            <button
                              type="button"
                              className="w-1/2 h-full cursor-pointer bg-transparent border-0 p-0"
                              onClick={() => navigate(splitUrls.leftUrl)}
                              aria-label="Chicken Games"
                            />
                            <button
                              type="button"
                              className="w-1/2 h-full cursor-pointer bg-transparent border-0 p-0"
                              onClick={() => navigate(splitUrls.rightUrl)}
                              aria-label="Color Games"
                            />
                          </div>
                        ) : null}
                        <img
                          key={banner.id + index + "mobile"}
                          src={banner.publicUrl}
                          alt={banner.title}
                          className="w-[100%] h-[100px] sm:h-[113px] cursor-pointer"
                          onClick={splitUrls ? undefined : bannerNavigate}
                        />
                      </div>
                      <div className="flex w-full flex-shrink-0 absolute bottom-0 left-0 right-0 border-b-4 border-goldenYellow z-[1]">
                        <div
                          className="flex flex-1 items-center bg-gradient-to-r from-black to-transparent text-white pl-2 pr-1 py-1 text-xs md:text-sm font-bold cursor-pointer min-w-0 capitalize break-words"
                          onClick={chickenNavigate}
                        >
                          {banner.title}
                        </div>
                        <button
                          type="button"
                          className="flex items-center justify-center flex-shrink-0 bg-goldenYellow bg-[linear-gradient(110deg,#FFB600_0%,#FFB600_38%,#FFF1B8_50%,#FFB600_62%,#FFB600_100%)] bg-[length:250%_100%] animate-playNow text-[#1A1A1A] px-2 pl-4 py-1 text-[12px] font-extrabold leading-[120%] tracking-[0.02em] [text-shadow:0_1px_0_rgba(255,255,255,0.6)] cursor-pointer min-w-[70px] [clip-path:polygon(15%_0,100%_0,100%_100%,0_100%)] hover:brightness-110"
                          onClick={(e) => {
                            e.stopPropagation();
                            chickenNavigate?.();
                          }}
                        >
                          Play Now
                        </button>
                      </div>
                    </div>
                  );
                },
              )}
            </div> */}
            {/* <HomeGames
              isLoggedIn={loggedIn}
              showPopUp={() => setShowLoginPopup(true)}
              casinoGames={casinoGames}
            /> */}
          </div>


          <div className=" flex-col flex items-center sm:px-0 gap-3 ">
            <div className="grid w-[calc(100%-30px)] max-w-[670px] mx-auto grid-cols-2 gap-2.5">
              {FOOTER_CONTACT_GROUPS.map(
                ({ match, Icon, fullWidth, dummy }) => {
                // Labels come from the placeholder rows; each one links to the
                // matching configured contact, falling back to the first.
                const configured = contactsMatching(match);
                const entries = dummy.map((row, index) => {
                  const value = configured[index] ?? configured[0];
                  return {
                    label: row.label,
                    href: value ? contactHref(match, value) : row.href,
                  };
                });

                return (
                  <div
                    key={match}
                    className={`${
                      fullWidth ? "col-span-2" : "col-span-1"
                    } flex items-center justify-center gap-2.5 rounded-lg border border-[#999] bg-white px-5 py-3 shadow-[0_1px_3px_rgba(0,0,0,0.08)]`}
                  >
                    <Icon className="h-[22px] w-[22px] shrink-0 text-[#555]" />
                    {entries.map((entry, index) => (
                      <div key={entry.label} className="flex items-center">
                        {index > 0 && (
                          <span className="mx-3.5 h-4 w-px bg-[#d6d6d6]" />
                        )}
                        <a
                          href={entry.href}
                          target="_blank"
                          rel="noreferrer"
                          className="text-[14px] text-[#666] hover:text-[#333]"
                        >
                          {entry.label}
                        </a>
                      </div>
                    ))}
                  </div>
                );
                },
              )}
            </div>

            <div className="flex md:hidden flex-wrap justify-center w-[calc(100%-22px)] max-w-[670px] mx-auto text-[14px] leading-[120%] tracking-[0.04em] text-[#666] text-center gap-y-2.5 py-3">
              {FOOTER_POLICY_LINKS.map((link, index) => (
                <span
                  key={link.label}
                  onClick={() => link.href && navigate(link.href)}
                  className={`inline-block underline whitespace-nowrap px-2 ${
                    link.href ? "cursor-pointer" : ""
                  } ${
                    index < FOOTER_POLICY_LINKS.length - 1
                      ? "border-r border-[#999]"
                      : ""
                  }`}
                >
                  {link.label}
                </span>
              ))}
            </div>

            {isApkAvailable && (
              <div className="flex md:hidden flex-col items-center gap-1">
                <button
                  type="button"
                  onClick={downloadApp}
                  className="cursor-pointer transition-all hover:brightness-110"
                  aria-label={langData?.["download_apk"] ?? "Download Android APP"}
                >
                  <img
                    src={downloadAndroidApp}
                    alt=""
                    className="h-[46px] w-auto"
                  />
                </button>
                {apkMeta && (
                  <div className="text-[11px] text-gray5">{apkMeta}</div>
                )}
              </div>
            )}

            <Modal
              isOpen={showApkQrModal}
              onClose={() => setShowApkQrModal(false)}
              maxWidthClass="max-w-[28%]"
              hideCloseIcon
              closeOnContentClick={false}
              title={
                langData?.["scan_to_download_apk"] ??
                "Scan to download Android APP"
              }
            >
              <div className="flex flex-col items-center gap-5 py-2">
                <div className="rounded-xl border border-gray17 bg-white p-4">
                  {apkDownloadUrl ? (
                    <QRCode
                      value={apkDownloadUrl}
                      size={240}
                      className="h-[240px] w-[240px]"
                    />
                  ) : (
                    <div className="flex h-[240px] w-[240px] items-center justify-center text-center text-[13px] text-gray5">
                      {langData?.["apk_not_available"] ??
                        "Download link is not available right now."}
                    </div>
                  )}
                </div>
                <Button
                  className="w-full rounded-md bg-header-gradient py-2.5 font-bold text-goldenYellow"
                  onClick={() => setShowApkQrModal(false)}
                >
                  {langData?.["close"] ?? "Close"}
                </Button>
              </div>
            </Modal>

            <div className="flex flex-row items-center gap-2.5 w-[calc(100%-30px)] max-w-[670px] mx-auto mb-[75px] md:mb-0 rounded-lg bg-gray11 border border-[#bbb] p-2.5 text-[#4d4d4d]">
              <img
                src={LICImage}
                alt="licence-seal"
                className="w-[48px] md:w-[56px] h-auto shrink-0 object-contain"
              />
              <span className="text-[11px] font-normal text-center leading-[167%] w-full">
                {BRAND_DOMAIN} is operated by RWB Solutions International Ltd, a
                limited liability company registered in Belize with company
                registration number 000045551, with registered address at Sea
                Urchin Street, San Pedro, Ambergris Caye, Belize ("RWB Solutions
                International Ltd"), licensed in the State of Anjouan under the
                Computer Gaming Licensing Act 007 of 2005.
              </span>
            </div>

            {isDesktop && (
              <div className="hidden w-full md:flex flex-col gap-2 items-center md:px-12 lg:px-20">
                <div className="text-center text-xs text-gray5 px-4">
                  Our website works best in the newest and last prior version of
                  these browsers: Google Chrome. Firefox
                </div>
                <div className="h-[1px] w-[76%] bg-black2" />
              </div>
            )}
            {/* Desktop copy — on mobile these sit above the licence panel */}
            <div className="hidden md:flex flex-wrap justify-center mx-auto text-[12px] leading-[120%] text-[#666] text-center gap-y-2.5">
              {FOOTER_POLICY_LINKS.map((link, index) => (
                <span
                  key={link.label}
                  onClick={() => link.href && navigate(link.href)}
                  className={`inline-block underline whitespace-nowrap px-2 ${
                    link.href ? "cursor-pointer" : ""
                  } ${
                    index < FOOTER_POLICY_LINKS.length - 1
                      ? "border-r border-[#999]"
                      : ""
                  }`}
                >
                  {link.label}
                </span>
              ))}
            </div>

            {isApkAvailable && (
              <div className="hidden md:flex flex-col items-center gap-1 pb-10">
                <button
                  type="button"
                  onClick={() => setShowApkQrModal(true)}
                  className="cursor-pointer transition-all hover:brightness-110"
                  aria-label={langData?.["download_apk"] ?? "Download Android APP"}
                >
                  <img
                    src={downloadAndroidAppQr}
                    alt=""
                    className="h-[46px] w-auto"
                  />
                </button>
                {apkMeta && (
                  <div className="text-[11px] text-gray5">{apkMeta}</div>
                )}
              </div>
            )}
            {/* {isDesktop && (
              <div className="grid grid-cols-10 md:flex justify-center w-full text-[13px] md:text-[11px] text-black3 md:text-black underline gap-3 text-center">
                <span className="col-span-4 cursor-pointer text-right">
                  Privacy Policy
                </span>
                <span className="col-span-4 cursor-pointer text-right">
                  Terms And Conditions
                </span>
                <span className="col-span-6 cursor-pointer text-left">
                  Rules And Regulations
                </span>

                <span className="col-span-4 cursor-pointer">About Us</span>
                <span className="col-span-4 cursor-pointer">
                  Responsible Gaming
                </span>
              </div>
            )} */}
            {/* <div className="self-center">
            <img
              src={MobileAppQRImage}
              alt="mobile-app-qr"
              className="w-[150px]"
            />
          </div> */}
          </div>
        </div>
      </div>

      {/* Mini Games lives in the mobile footer; on widths where that footer is
          hidden, fall back to the original floating badge */}
      <div className="hidden md:block">
        {isMobile || isIOS ? <YuviGames /> : null}
      </div>

      <div className="md:hidden">
        <MobileFooter />
      </div>

      <div>
        {showApkPopup && isApkAvailable ? (
          <ClientSecurityMessageModal
            isOpen={showApkPopup}
            onClose={closeApkPopup}
            isContentWidth
            hideCloseIcon
            modalBg="bg-transparent"
            showCloseIconInsideContent
          >
            <img
              src={
                isMobile
                  ? downloadApkMobileBanner?.publicUrl
                  : downloadApkBanner?.publicUrl
              }
              onClick={downloadApp}
              className={isMobile ? "" : "max-h-[66vh]"}
            />
          </ClientSecurityMessageModal>
        ) : (
          showPopup &&
          popupBanner &&
          popupMobileBanner && (
            <ClientSecurityMessageModal
              modalBg="bg-transparent"
              isOpen={showPopup}
              onClose={closePopup}
              hideCloseIcon
              isContentWidth
              showCloseIconInsideContent={true}
            >
              <img
                src={
                  isMobile
                    ? popupMobileBanner?.publicUrl
                    : popupBanner?.publicUrl
                }
                onClick={handlePopupBannerClick}
                className={`cursor-pointer ${isMobile ? "" : "max-h-[66vh]"}`}
              />
            </ClientSecurityMessageModal>
          )
        )}
      </div>

      {whatsappLink && (
        <a
          href={whatsappLink}
          target="_blank"
          rel="noreferrer"
          className={`bottom-[70px] left-[3px] z-50 flex h-[4rem] w-12 items-center justify-center rounded-full shadow-lg hover:opacity-90 md:bottom-6 md:left-6 md:h-14 md:w-14 ${
            showWhatsapp ? "fixed" : "hidden"
          }`}
          aria-label="WhatsApp"
        >
          <MdOutlineCancel
            height={20}
            width={20}
            className="absolute -top-0 -right-1 z-10 rounded-full bg-white"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowWhatsapp(false);
            }}
          />
          <img
            src={whatsappIconGreen}
            alt="WhatsApp"
            className="h-full w-full object-contain"
          />
        </a>
      )}
      <SkinsRail />
    </div>
  );
};
const mapStateToProps = (state: RootState) => {
  return {
    balance: state.auth.balanceSummary.balance,
    exposure: state.auth.balanceSummary.exposure,
    loggedIn: state.auth.loggedIn,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
